import React from "react";
import { Layout, Row, Col, Card, Typography, Space } from "antd";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  CloudOutlined,
  ThunderboltOutlined,
  DatabaseOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";

const { Header, Content } = Layout;
const { Text, Title } = Typography;

const data = [
  { name: "Day 1", spend: 120 },
  { name: "Day 2", spend: 200 },
  { name: "Day 3", spend: 150 },
  { name: "Day 4", spend: 250 },
  { name: "Day 5", spend: 300 },
  { name: "Day 6", spend: 180 },
  { name: "Day 7", spend: 220 },
];

const Dashboard = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Content */}
      <Content style={{ padding: 16 }}>
        {/* Top Cards */}
        <Row gutter={[16, 16]}>
          <Col xs={24} >
            <Card title=" Deploy GPU Pod" bordered={false}>
              <Space size="large">
                <Text>Docs</Text>
                <Text>Referrals</Text>
                <Text>$0.00</Text>
              </Space>
            </Card>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          
          <Col xs={24} sm={12} md={6}>
            <Card title="GPU Cloud" bordered={false}>
              <CloudOutlined style={{ color: "#673ab7" }} /> Deploy a GPU pod.
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card title="Serverless" bordered={false}>
              <ThunderboltOutlined style={{ color: "#673ab7" }} /> Autoscale
              workloads.
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card title="Storage" bordered={false}>
              <DatabaseOutlined style={{ color: "#673ab7" }} /> Shared network
              storage.
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card title="Earn Credits" bordered={false}>
              <DollarCircleOutlined style={{ color: "#673ab7" }} /> Earn 6%
              referral credits.
            </Card>
          </Col>
        </Row>

        {/* Graph + Resources */}
        <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
          <Col xs={24} lg={16}>
            <Card title="Usage" bordered={false}>
              <Text>Daily spend overview</Text>
              <div style={{ height: 250 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Line
                      type="monotone"
                      dataKey="spend"
                      stroke="#8884d8"
                      strokeWidth={2}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card title="Resources" bordered={false}>
              <Row>
                <Col span={12}>GPUs</Col>
                <Col span={12}>0</Col>
              </Row>
              <Row>
                <Col span={12}>vCPUs</Col>
                <Col span={12}>0</Col>
              </Row>
              <Row>
                <Col span={12}>Storage</Col>
                <Col span={12}>0 GB</Col>
              </Row>
              <Row>
                <Col span={12}>Endpoints</Col>
                <Col span={12}>0</Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default Dashboard;
